import { render, staticRenderFns } from "./ProjectRating.vue?vue&type=template&id=7ef4fb80&"
import script from "./ProjectRating.vue?vue&type=script&lang=js&"
export * from "./ProjectRating.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRating.vue?vue&type=style&index=0&id=7ef4fb80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports